import Styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import { deleteDoc, doc, getDoc, getDocs, getFirestore, onSnapshot, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { calcScore, ScoreCircle } from '../../13.score/index';
import { companyIdFromParentId, jobPostingYearCollection } from '../../2.jobPostings/jobPostingRef';
import { registerJobPostingSearchIndex } from '../../2.jobPostings/edit/navigation/searchIndexSync';

type SchoolUnPublic = {
  documentId: string;
};

const SchoolUnPublic: React.FC<SchoolUnPublic> = ({ documentId }) => {

  const db = getFirestore();
  const navigate = useNavigate();
  const [totalScore, setTotalScore] = useState<number | null>(null);

  useEffect(() => {
    if (!documentId) return;
    const unsub = onSnapshot(doc(db, 'recruits', documentId), (snap) => {
      if (snap.exists()) {
        const result = calcScore(snap.data());
        setTotalScore(result.totalScore);
      }
    });
    return () => unsub();
  }, [documentId]);

  const scoreColor = (score: number) => {
    if (score >= 80) return '#4CAF50';
    if (score >= 40) return '#EAC630';
    return '#E44E70';
  };

  const gradeLabel = (score: number) => {
    if (score >= 80) return '良好';
    if (score >= 40) return '改善推奨';
    return '要改善';
  };

  // 求人票がいずれかの年度で確定済みか(2027年度は旧フローの確定フラグが
  // フラットドキュメントにだけ立っている場合もある)
  const isJobPostingPublished = async (companyId: string) => {
    const flatSnap = await getDoc(doc(db, 'recruits', documentId));
    if (flatSnap.data()?.jobPostingsStatus === 1) return true;
    const yearsSnap = await getDocs(jobPostingYearCollection(db, companyId));
    return yearsSnap.docs.some((d) => d.data()?.jobPostingsStatus === 1);
  };

  const unPublic = async () => {
    await updateDoc(doc(db, 'recruits', documentId), {
      recruitStatus: 3,
    });

    // searchIndex は求人ページと求人票で共用のため、求人票が確定済みなら削除せず
    // 求人票だけの内容(recruitStatus: false)に作り直す。削除すると、アプリの検索結果や
    // 学校側の求人一覧から求人票まで消えてしまう。
    const companyId = companyIdFromParentId(documentId);
    if (await isJobPostingPublished(companyId)) {
      await registerJobPostingSearchIndex(companyId);
    } else {
      await deleteDoc(doc(db, "searchIndex", documentId));
    }
  };

  return (
    <>
    <div className='works_service'>
      <div className={Styles.modal_contents}>
        <h4>求人 公開中</h4>
        <p className={Styles.modal_contents_p}>
          求人は現在公開中です。再編集を行う場合は、以下ボタンより一度求人を非公開にしてください。<br />
        </p>
        <button onClick={() => unPublic()} className={Styles.btn}>非公開にする</button>
        <a href={`https://memorii-works.com/recruit/id=${documentId}`} target="_blank" rel="noreferrer noopener">
          <p className={Styles.check}>求人を確認する</p>
        </a>
      </div>

      {totalScore !== null && (
        <div className={Styles.score_card}>
          <ScoreCircle score={totalScore} max={100} />
          <div className={Styles.score_info}>
            <div className={Styles.score_grade} style={{ color: scoreColor(totalScore) }}>
              {gradeLabel(totalScore)}
            </div>
            <h3 className={Styles.score_title}>求人クオリティスコア</h3>
            <p className={Styles.score_desc}>各セクションを充実させると求職者への訴求力が上がります。</p>
            <button className={Styles.score_link} onClick={() => navigate('/service/score')}>
              詳しくはこちら →
            </button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default SchoolUnPublic;
